module.exports = __webpack_public_path__ + "img/Slider2.49824c3c.svg";